import React from 'react';
import { Checkbox as CheckboxInput, InfoTooltip, withFormikSupport } from '@fourthwall/components';
import * as S from './Checkbox.styled';
const CheckboxComponent = ({ data, value, onChange, onBlur, onSettingUpdate }) => {
    const { label, id, info } = data;
    const handleChange = (newValue) => {
        onChange(newValue);
        onSettingUpdate(id, newValue);
    };
    const handleBlur = (e) => {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    const getValue = () => {
        if (typeof value === 'string') {
            return value === 'true';
        }
        return value;
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.CheckboxContainer, null,
            React.createElement(CheckboxInput, { label: label, value: getValue(), onValueChange: handleChange, onBlur: handleBlur })),
        React.createElement(InfoTooltip, { content: info })));
};
export const Checkbox = withFormikSupport(CheckboxComponent);
